import { render, staticRenderFns } from "./ApptitudeTestType.vue?vue&type=template&id=3de1e820&scoped=true"
import script from "./ApptitudeTestType.vue?vue&type=script&lang=js"
export * from "./ApptitudeTestType.vue?vue&type=script&lang=js"
import style0 from "./ApptitudeTestType.vue?vue&type=style&index=0&id=3de1e820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de1e820",
  null
  
)

export default component.exports